// extracted by mini-css-extract-plugin
export default {"Work":"Work_Work__t2IH3","WorkCard":"Work_WorkCard__A3P6g","WorkImg":"Work_WorkImg__Xmgi7","LogoOnly":"Work_LogoOnly__oGLa7"};